export const BenchmarkModalView = Object.freeze({
  BENCHMARK_CHOICE: 'benchmark_choice',
  BENCHMARK_GROUP: 'benchmark_group',
  BENCHMARK_SPORTER: 'benchmark_sporter',
  BENCHMARK_SESSION: 'benchmark_session'
});
